<template>
  <div>
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="referenceNumber"
          v-model="referenceNumber"
          v-validate="{ required: false }"
          data-vv-as="Reference No."
          type="text"
          maxlength="50"
          name="referenceNumber"
          label-content="Reference Number"
          :placeholder="placeholders.referenceno"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('referenceNumber') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="taxID"
          v-model="taxID"
          v-validate="{
            required: false,
          }"
          validattor="^[0-9]+$"
          data-vv-as="Tax ID"
          type="text"
          name="taxID"
          maxlength="9"
          label-content="Tax ID"
          :placeholder="placeholders.taxID"
          :class="{
            input: true,
            'is-danger': errors.has('taxID'),
          }"
          aria-describedby="taxID-live-feedback"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxID') }}
        </div>
      </b-col>
      <b-col md="6"> </b-col>
      <!-- <b-col md="12" class="border-bottom pb-3" /> -->
    </b-row>

    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            label="Business Information"
            :class="$style.labelSubHeading"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="businessName"
          v-model="businessName"
          v-validate="{ required: true }"
          data-vv-as="Business Name"
          type="text"
          name="businessName"
          maxlength="100"
          mark-required
          label-content="Name"
          :class="{
            input: true,
            'is-danger': errors.has('businessName'),
          }"
          :placeholder="placeholders.businessName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('businessName') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :class="{
            input: true,
            'is-danger': errors.has('phoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('phoneNumber') }}
        </div>
      </b-col>
    </b-row>
    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Commercial Address"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="commercialstreetAddress"
          v-model="commercialstreetAddress"
          type="text"
          name="commercialstreetAddress"
          maxlength="100"
          data-vv-as="Street"
          label-content="Street"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('commercialstreetAddress') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="commercialCityName"
          v-model="commercialCityName"
          v-validate="{ required: true, regex: /^[A-Za-z -.]+$/ }"
          validattor="^[A-Za-z -.]+$"
          type="text"
          name="commercialCityName"
          maxlength="20"
          label-content="City"
          mark-required
          data-vv-as="City Name"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('commercialCityName') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="commercialState"
          v-validate="'required'"
          :field-id="commercialState"
          :options="states"
          name="commercialState"
          :placeholder="placeholders.state"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
        <div v-show="errors.has('commercialState')" class="error">
          State is required
        </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="commercialZip"
          v-model="commercialZip"
          v-validate="{ required: false, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="commercialZip"
          label-content="Zip"
          data-vv-as="Zip"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('commercialZip') }} </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 border-bottom">
      <b-col class="col-9">
        <BaseTextarea
          id="commercialComments"
          v-model="commercialComments"
          v-validate="{ required: false }"
          maxlength="30"
          name="commercialComments"
          label-content="Comments"
        ></BaseTextarea>
        <div class="error"> {{ errors.first('commercialComments') }} </div>
      </b-col>
    </b-row>
    <!--New BOPR section start-->
    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            label="Personal Information"
            :class="$style.labelSubHeading"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="firstName"
          v-model="firstName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9]+$/,
          }"
          validattor="^[A-Za-z0-9]+$"
          data-vv-as="First Name"
          type="text"
          name="firstName"
          maxlength="30"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('firstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName-live-feedback"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('firstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="middleName"
          v-model="middleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9]+$/ }"
          validattor="^[A-Za-z0-9]+$"
          data-vv-as="Middle Name"
          type="text"
          name="middleName"
          maxlength="30"
          label-content="Middle Name"
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('middleName') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="lastName"
          v-model="lastName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9]+$/,
          }"
          validattor="^[A-Za-z0-9]+$"
          data-vv-as="Last Name"
          type="text"
          name="lastName"
          maxlength="30"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('lastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('lastName') }} </div>
      </b-col>
    </b-row>
    <b-row> </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="ssn"
          v-model="ssn"
          v-validate="{
            required: true,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          name="ssn"
          label-content="SSN"
          data-vv-as="SSN"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('ssn'),
          }"
          :placeholder="placeholders.ssn"
          @input="formatSSN"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('ssn') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel label="Date of Birth" />
        <BaseDate
          v-model="dateofBirth"
          type="date"
          :field-id="dateofBirth"
          name="dateofBirth"
          data-vv-as="Date of Birth"
          :max="maxbirtdate"
          :class="{
            input: true,
            'is-danger': errors.has('dateofBirth'),
          }"
        ></BaseDate>
        <div class="error">
          {{ errors.first('dateofBirth') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="personalInfophoneNumber"
          v-model="personalInfophoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :class="{
            input: true,
            'is-danger': errors.has('personalInfophoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('personalInfophoneNumber') }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="driverLicenseNumber"
          v-model="driverLicenseNumber"
          v-validate="{
            required: driverLicenseState === '' ? false : true,
            regex: /[A-Za-z0-9]/,
            min: 4,
          }"
          validattor="[A-Za-z0-9]"
          type="text"
          maxlength="20"
          name="driverLicenseNumber"
          label-content="Driver's License Number"
          data-vv-as="Driver's License Number"
          :mark-required="driverLicenseState === '' ? false : true"
          :class="{
            input: true,
            'is-danger': errors.has('driverLicenseNumber'),
          }"
          :placeholder="placeholders.driverLicenseNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('driverLicenseNumber') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel
          :mark-required="driverLicenseNumber === '' ? false : true"
          label="Driver's License State"
        />
        <BaseDropdown
          v-model="driverLicenseState"
          v-validate="{
            required: driverLicenseNumber === '' ? false : true,
          }"
          data-vv-as="Driver's License State"
          :field-id="driverLicenseState"
          :options="states"
          class="mb-1"
          name="driverLicenseState"
          :placeholder="placeholders.driverLicenseState"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
        <div class="error">
          {{ errors.first('driverLicenseState') }}
        </div>
      </b-col>
    </b-row>

    <!--New BOPR section ends-->
    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Residental Address"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          type="text"
          name="streetAddress"
          maxlength="100"
          data-vv-as="Street"
          label-content="Street"
          :class="{
            input: true,
            'is-danger': errors.has('street'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('streetAddress') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: true, regex: /^[A-Za-z -.]+$/ }"
          validattor="^[A-Za-z -.]+$"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          mark-required
          data-vv-as="City Name"
          :class="{
            input: true,
            'is-danger': errors.has('cityName'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('cityName') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          :field-id="state"
          :options="states"
          name="state"
          :placeholder="placeholders.state"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
        <div v-show="errors.has('state')" class="error">
          State is required
        </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: false, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          data-vv-as="Zip"
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('zip') }} </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 border-bottom">
      <b-col class="col-9">
        <BaseTextarea
          id="comments"
          v-model="comments"
          v-validate="{ required: false }"
          maxlength="30"
          name="comments"
          label-content="Comments"
        ></BaseTextarea>
        <div class="error"> {{ errors.first('comments') }} </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="2">
        <BaseEButton @click="onSearch">
          Search
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.dropOptionstyle option {
  font-size: 16px;
}
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
<script>
import {
  experianBlendedReportMethods,
  toasterMethods,
} from '@state/helpers'
import constant from '@constants/constant'
export default {
  props: {
    customerId: {
      type: Number || String,
      default: '',
    },
    customerUserId: {
      type: Number || String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    searchData: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      commercialstreetAddress: '',
      commercialCityName: '',
      commercialState: '',
      commercialZip: '',
      commercialComments: '',
      errorLog: '',
      showSpinner: false,
      referenceNumber: null,
      taxID: null,
      businessName: '',
      maxbirtdate: '',
      streetAddress: null,
      state: '',
      stateCode: '',
      zip: null,
      phoneNumber: '',
      cityName: '',
      comments: null,
      requestData: '',
      firstName:'',
      middleName:'',
      lastName:'',
      ssn:'',
      dateofBirth:'',
      personalInfophoneNumber:'',
      driverLicenseNumber:'',
      driverLicenseState:'',
      currentUserId: '',
    }
  },
  computed: {
    placeholders() {
      return {
        referenceno: 'Reference Number',
        businessName: 'Business Name',
        cityName: 'City Name',
        state: 'Select State',
        ssn: 'xxx-xx-xxxx',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        zip: 'xxxxx-xxxx',
        streetAddress: 'Street Address',
        phoneNumber: '(xxx) xxx-xxxx',
        taxID: 'xxxxxxxxx',
        driverLicenseNumber: "Driver's License Number",
        driverLicenseState: "Driver's License State",
      }
    },

    states() {
      return this.$_allStates
    },
    SEARCH_DATA(){
      return this.searchData || null
    },
  },
  mounted() {
    this.getMaxDateLimit()
    if (this.SEARCH_DATA) {
      this.loadRefineSearch()
    }
  },

  methods: {
    ...experianBlendedReportMethods,
    ...toasterMethods,
    formatSSN() {
      this.ssn = this.ssn.replace(' ', '')
    },
    buildExpBlendedReport() {
      return JSON.stringify({
        UserId: this.currentUserId,
        ReferenceNumber: this.referenceNumber,
        OrderForCustomer: this.customerId,
        OrderForUser: this.customerUserId,
        ProductId: this.productId,
        IPBRRequest : {
          Borrower: {
          FirstName: this.firstName,
          MiddleName: this.middleName,
          LastName: this.lastName,
          DriverLicenseNumber: this.driverLicenseNumber,
          DriverLicenseStateId: Number(this.driverLicenseState),
          DriverLicenseStateCode: this.driverLicenseStateCode,
          SSN: this.ssn,
          DateOfBirth: this.dateofBirth,
          Address: {
             AddressType: constant.currentAddress,
             Street: this.streetAddress,
             City: this.cityName,
             StateId: this.state,
             StateCode: this.getStateCode(this.state),
             Zip: this.zip,
           },
          Contacts: {
            PhoneNumber: this.personalInfophoneNumber,
          },
          Comments: this.comments,
        },
        },
        SearchRequest : {
          Comments: this.commercialComments,
          Business: {
            TaxId: this.taxID,
            Name: this.businessName,
          },
          Address: {
            AddressType: constant.currentAddress,
            Street: this.commercialstreetAddress,
            City: this.commercialCityName,
            StateId: this.commercialState,
            StateCode: this.getStateCode(this.commercialState),
            Zip: this.commercialZip,
          },
          Contact: {
            PhoneNumber: this.phoneNumber,
          },
        },
      })
    },
    onSearch(selectedValue) {
      let userInfo = this.$store.state.auth.currentUser.userInfo
      var isOrderReportComponentValid = false
      var isExpPremierProfileReportComponentValid = false
      this.currentUserId = userInfo.userId
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          isExpPremierProfileReportComponentValid = response
          if (
            isOrderReportComponentValid &&
            isExpPremierProfileReportComponentValid
          ) {
            this.showSpinner = true
            this.requestData = this.buildExpBlendedReport()
            this.fetchBlendedSearchReport({
                expBlendedReportData: this.requestData,
              })
              .then((response) => {
                if(response.status === 200 && response.data !== null) {
                  if(response.data.ipbrRequest !== null) {
                    this.$router.push({
                    name: 'blendedSearchResults',
                    params: {
                      searchResponse: response.data,
                      searchRequest: this.requestData,
                      searchFor: this.businessName,
                    },
                    })
                  }
                }
                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
                this.errorLog = error
              })
          }
        })
      })
    },
    loadRefineSearch() {
      if(this.SEARCH_DATA !== null) {
        this.showSpinner = true
        this.searchData = JSON.parse(this.searchData)
        this.referenceNumber = this.SEARCH_DATA.ReferenceNumber
        let searchReqObj = this.SEARCH_DATA.SearchRequest
        this.taxID = searchReqObj.Business.TaxId
        this.businessName = searchReqObj.Business.Name
        this.phoneNumber = searchReqObj.Contact.PhoneNumber

        let commercialAddress = searchReqObj.Address
        this.commercialstreetAddress = commercialAddress.Street
        this.commercialCityName = commercialAddress.City
        this.commercialState = commercialAddress.StateId
        this.commercialZip = commercialAddress.Zip
        this.commercialComments = searchReqObj.Comments

        let personalInfo = this.SEARCH_DATA.IPBRRequest.Borrower
        this.firstName = personalInfo.FirstName
        this.middleName = personalInfo.MiddleName
        this.lastName = personalInfo.LastName
        this.ssn = personalInfo.SSN
        this.dateofBirth = personalInfo.DateOfBirth
        this.personalInfophoneNumber = personalInfo.Contacts.PhoneNumber
        this.driverLicenseNumber = personalInfo.DriverLicenseNumber || ''
        this.driverLicenseState = personalInfo.DriverLicenseStateId || ''

        let residentialAddress = personalInfo.Address
        this.streetAddress = residentialAddress.Street
        this.cityName = residentialAddress.City
        this.state = residentialAddress.StateId
        this.zip = residentialAddress.Zip
        this.comments = personalInfo.Comments
        this.showSpinner = false
      }
    },
    getStateCode(stateValue) {
      if (stateValue !== '') {
        var stateCode = this.states.find(
          (x) => x.value === Number(stateValue)
        ).stateCode
      }
      return stateCode
    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
  },
}
</script>
